export default "__VITE_ASSET__BAg7DLDw__"